



















import { Component, Vue } from "vue-property-decorator";
import CsvDateEdit from "../components/CsvDateEdit.vue";
import { getCsvDate, saveCsvDate } from "../../api/csv-date-api";
import SubmitButton from "@/components/SubmitButton.vue";
import CsvdateFormDate from "../../models/factories/CsvDateFormData";
import createCsvDateOutput from "../../models/factories/createCsvDateOutput";
@Component({
  components: {
    CsvDateEdit,
    SubmitButton
  }
})
export default class CsvDateEditPage extends Vue {
  csvDate = createCsvDateOutput();

  private created() {
    this.initCsvDate();
  }

  private async initCsvDate() {
    this.csvDate = await getCsvDate();
  }
  chengeDate = "";
  async submit() {
    if (!this.csvDate) return;
    // this.csvDate.chengeDate = this.chengeDate;
    const d = CsvdateFormDate(this.csvDate);
    await saveCsvDate(d);
  }
  status = "";
  //   submit() {
  //     this.status = "progressing";
  //     this.$emit("ok");
  //   }
}
